<template>
  <div>
    <header>
      <h1>公告</h1>
      <div class="more">
        <span>更多</span>
        <i class="el-icon-arrow-right" />
      </div>
    </header>

    <vuescroll :ops="$store.state.vueScrollOps">
      <ul v-if="list.length" class="content">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="ellipsis"
          @click="
            itemText = item.title;
            show = true;
          "
        >
          {{ item.title }}
        </li>
      </ul>
      <div v-else class="content nodata">
        暂无数据
      </div>
    </vuescroll>
    <nf-confirm
      :show.sync="show"
      :is-savel-btn="false"
      :is-cancel-btn="false"
      scrollbar-h="150px"
      title="公告"
      :handle-save-btn-click="handleSaveBtnClick"
    >
      <div slot="content" style="line-height:30px;">
        {{ itemText }}
      </div>
    </nf-confirm>
  </div>
</template>
<script>
import vuescroll from 'vuescroll';
import Axios from 'axios';

export default {
  components: {
    vuescroll,
  },
  data() {
    return {
      list: [],
      itemText: '',
      show: false,
    };
  },
  async created() {
    try {
      let hostName = window.Location.hostName;
      let baseUrl = 'ci';
      if (hostName.includes('cn')) {
        baseUrl = 'qa';
      } else if (hostName.includes('com')) {
        baseUrl = 'prod';
      }

      let { data } = await Axios.get('/ad/notice/' + baseUrl + '/notice.json');
      this.list = data;
    } catch (err) {
      // this.$$message('获取公告失败:'+err,'error')
    }
  },
};
</script>
<style lang="scss" scoped>
@import url('./right.css');
.content {
  padding: 0 20px 25px;
  height: 257px;
  li {
    height: 44px;
    line-height: 44px;
    width: 468px;
    background: rgba(244, 247, 250, 1);
    font-size: 14px;
    cursor: pointer;
    font-weight: 400;
    color: rgba(32, 44, 85, 1);
    position: relative;
    padding-left: 20px;
    &::after {
      content: '';
      position: absolute;
      width: 4px;
      height: 5px;
      background: #9faebc;
      left: 8px;
      top: 20px;
    }
  }
  li:nth-child(2n) {
    background: #fff;
    height: 50px;
    line-height: 50px;
  }
}
.nodata {
  align-items: center;
  justify-content: center;
  display: flex;
  color: #333;
}
header {
  border: 0 !important;
}
</style>
